import React, { useState } from "react";
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from "primereact/button";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import statuses from 'data/task-question-status.json'
import { Tag } from 'primereact/tag';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { useResponsibleManagers, useParentTaskOwner } from "hooks/taskHooks";


const NeedHelpDialog = ({visible, onHide, needHelpQuestionList, onUpdateQuestionList, task}) => {
    const [question, setQuestion] = useState(""); 
    const finalStatuses = statuses.filter(e => e.complete);
    const [date, setDate] = useState(new Date());
    const managers = useResponsibleManagers([]);
    const ownerParentTask = useParentTaskOwner(task);

    const addMessage = () => {
        if(question && question.trim()) {
            const newQuestionList = needHelpQuestionList || [];
            newQuestionList.push ({
                    text: question,
                    deadline: date?.getTime() ?? new Date().getTime()
            });
            onUpdateQuestionList(newQuestionList);
            setQuestion("");
        }
    }


    const statusColumn = (row) => {
        const status = statuses.find(e => e.code === row.status);
        return <Tag value={status?.text} severity={status?.severity}></Tag>;
    };

    const deadlineColumn = (row) => {
        return (row.deadline? new Date(row.deadline) : new Date()).toLocaleDateString();
    };


    const createdAtColumn = (row) => {
        return (row.createdAt? new Date(row.createdAt) : new Date()).toLocaleDateString();
    };

    
    const statusEditor = (options) => {
        const status = statuses.find(e => e.code === options.rowData.status);

        if(status.complete) {
            return statusColumn(options.rowData);
        } else return (
        <>
              <Dropdown value={options.value} onChange={(e) => options.editorCallback(e.target.value)} options={finalStatuses} optionLabel="completeActionText" optionValue="code" 
                    placeholder="Resolve Question" className="w-full md:w-14rem" />  
        </>);
        
    };


    const dateEditor = (options) => {
        const status = statuses.find(e => e.code === options.rowData.status);
        const value = options.value? new Date(options.value) : 0;
        if(status.complete) {
            return deadlineColumn(options.rowData);
        } else return (
        <>
              <Calendar value={value} onChange={(e) => options.editorCallback(e.target.value)}/> 
        </>);
        
    };

    const descriptionEditor = (options) => {
        const status = statuses.find(e => e.code === options.rowData.status);

        if(status.complete) {
            return options.rowData.text;
        } else return (
        <>
            <InputText style={{ width: "100%" }} type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)}/>
        </>);
    };


    const onRowEditComplete = (evt) => {
       const foundQuestion = (needHelpQuestionList || []).find(e => e.id === evt.data?.id);
       if(foundQuestion) {
            foundQuestion.text = evt.newData.text;
            foundQuestion.status = evt.newData.status;
            foundQuestion.deadline = evt.newData.deadline?.getTime? evt.newData.deadline?.getTime() : evt.data.deadline;
            onUpdateQuestionList(needHelpQuestionList);
       }
    };


    const sendToManager = () => {
        if(!managers?.length) {
            return "";
        } else {
            let str = ownerParentTask?.id? (ownerParentTask.firstName + " " + ownerParentTask.lastName).trim() + " (" + ownerParentTask.email + ")" : "";
            
            if(!str) {
                managers.forEach((manager, idx) => {
                    if(manager) {
                        str += (manager.firstName + " " + manager.lastName).trim() + " (" + manager.email + ")" + (idx === managers.length -1? "" : ",");
                    }
                });
            }
            return <div>To be addressed to <b>{str}</b></div>;
        }
    }
    
   

    return (
        <Dialog header={`Need Help - ${task.name} (${task.taskType})`} visible={visible} style={{ width: '70vw' }} onHide={ onHide }>
            <div className="mb-3">
                {sendToManager()}
                <div style={{ width: '100%' }}  className="mt-1">
                    <InputText value={question} onChange={e => setQuestion(e.target.value)} style={{ width: '40vw' }}/>
                    <Calendar value={date} onChange={(e) => setDate(e.value)} className="ml-2"/>
                    <Button label="Send Question" className="ml-2" onClick={addMessage} />
                </div>
            </div>
            <DataTable value={needHelpQuestionList} dataKey="id" tableStyle={{ width: '100%' }} rows={5} editMode="row" onRowEditComplete={onRowEditComplete} >
                <Column field="text" header="Description" editor={(options) => descriptionEditor(options)}/>
                <Column field="status" header="Status" body={statusColumn} editor={(options) => statusEditor(options)}  />
                <Column field="deadline" header="Due date" body={deadlineColumn}   editor={(options) => dateEditor(options)} />
                <Column field="deadline" header="Created At" body={createdAtColumn}    />
                <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }} />
            </DataTable>
        </Dialog>
    );
}


export default NeedHelpDialog;
